import { Fragment } from 'react';
import { LogItem, LogItemProps } from './LogItem';
import { ActivityLogContainer } from './style';

export interface ActivityLogProps {
    items: LogItemProps[];
}

export const ActivityLog = ({ items }: ActivityLogProps) => (
    <ActivityLogContainer>
        {items.map(({ key, ...props }, index) => {
            const isLast = index === items.length - 1;

            return (
                <Fragment key={key}>
                    <LogItem last={isLast} {...props} />
                </Fragment>
            );
        })}
    </ActivityLogContainer>
);
